import { jsx } from "react/jsx-runtime";
import { CollectionCarousel } from "./CollectionCarousel.js";
function LucidWorksAdSet(props) {
  var _a;
  const { lucidworks_placement_name } = ((_a = props == null ? void 0 : props.entry) == null ? void 0 : _a.third_party_curation) || {};
  const AdSetComponent = {
    CollectionCarousel
  }[lucidworks_placement_name || ""];
  if (!AdSetComponent) {
    return null;
  }
  return /* @__PURE__ */ jsx(AdSetComponent, { ...props });
}
export {
  LucidWorksAdSet
};
